<template>
  <div class="container">
    <div class="container-widgets">
      <div v-if="loader" class="loader">
      carregant...
      </div>
      <div v-if="!loader">
        <Layout :data="data" :urlsData="urlsData" :tmpl="tmpl" />
      </div>
      <div v-if="error">
        Servei no disponible
      </div>
    </div>
  </div>
</template>

<script>
import Layout from './components/Layout'
export default {
  props: ['url', 'ginys'],
  data() {
    return {
      urlsData: JSON.parse(this.ginys),
      data: {},
      tmpl: '',
      loader: true
    }
  },
  components:{
    Layout
  },
  methods: {
  },
  async created(){
    this.loader = true
    this.error = false
    try{
      const res = await fetch(this.url)
      const response = await res.json()
      if(this.urlsData[0].id.indexOf('--') == -1){
        this.tmpl = this.urlsData[0].id
        this.data = await response.filter(item => item.tmpl == this.urlsData[0].id)
      }else{
        let tmpl = this.urlsData[0].id.split('--')[0]
        this.tmpl = tmpl
        if(this.tmpl == 'Reserves'){
          this.data = await response.filter(item => item.vars !== undefined && item.tmpl == 'Reserves' && item.vars.terminal == this.urlsData[0].id.split('--')[1])
          if(!this.data[0]){
             throw new Error();
           }
         
        }
        if(this.tmpl == 'AvuiFanEscala'){
          this.data = await response.filter(item => item.vars !== undefined && String(item.vars.tipusvaixell).replace('à', 'a') == this.urlsData[0].id.split('--')[1])
          if(!this.data[0]){
             throw new Error();
           }
        }
        if(this.tmpl == 'Tempsacces'){
          this.data = await response.filter(item => item.vars !== undefined && item.tmpl == 'Tempsacces' && item.vars.terminal == this.urlsData[0].id.split('--')[1])
           if(!this.data[0]){
             throw new Error();
           }
        }
        if(this.tmpl == 'AnualResum'){
          this.data = await response.filter(item => item.vars !== undefined && item.tmpl == 'AnualResum' && item.vars.any == this.urlsData[0].id.split('--')[1])
          if(!this.data[0]){
             throw new Error();
           }
        }
      }
    }
    catch(e){
      this.error = true;
    }
    
    this.loader = false
  }
};
</script>
